import { useEffect, useState } from "react";
import { CustomLoading } from "./CustomLoading";
import { Card, Line } from "ktm-ui";
import "../styles/Settings.css";
import EditGeneralSettingModal from "./EditGeneralSettingModal";
import CustomToolTip from "./CustomToolTip";

const EmailSettings = ({ policyId }) => {
  const [loading, setLoading] = useState(true);
  const [showEditGeneralModal, setShowEditGeneralModal] = useState(false);
  const [automaticEmails, setAutomaticEmails] = useState(null);
  const [
    showExcludeYearEndAndRunoffRemindersModel,
    setShowExcludeYearEndAndRunoffRemindersModel,
  ] = useState(false);
  const [
    excludeYearEndAndRunoffReminders,
    setExcludeYearEndAndRunoffReminders,
  ] = useState(null);

  useEffect(() => {
    getExcludeYearEndAndRunoffReminders();
    setLoading(false);
  }, []);

  useEffect(() => {
    getPaCampaignEmailsSetting();
  }, [automaticEmails]);

  const openEditGeneralModal = () => {
    setShowEditGeneralModal(true);
  };

  const getPaCampaignEmailsSetting = async () => {
    let response = await fetch(
      "/api/Settings/checkautomaticemails?policyId=" + policyId,
      { method: "GET" }
    );
    let data = await response.json();
    if (data.success === false) {
      alert(data.message);
      return;
    }
    setAutomaticEmails(data.isPaCampaignEmailDisabled.eligibility);
  };

  const updateAutomaticEmailSetting = async (eligibility) => {
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ policyId: policyId, eligibility: eligibility }),
    };

    const policyLogs = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        Note: "Automatic Emails Settings: " + eligibility,
        Action: "Policy Edit Automatic Emails Settings",
        PolicyId: policyId,
      }),
    };

    let response = await fetch(
      "/api/Settings/updateautomaticemails",
      requestOptions
    );
    let data = await response.json();
    if (data.success === false) {
      alert(data.message);
      return;
    }
    await getPaCampaignEmailsSetting().then(() => {
      fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
    });
  };

  const getExcludeYearEndAndRunoffReminders = async () => {
    let response = await fetch(
      `/api/Settings/getexcludeYearEndAndRunoffReminders?policyId=${policyId}`,
      { method: "GET" }
    );
    let data = await response.json();
    if (data.success === false) {
      alert(data.message);
      return;
    }
    setExcludeYearEndAndRunoffReminders(
      data.result.isExcludeYearEndAndRunoffReminders
    );
  };

  const updateExcludeYearEndAndRunoffReminders = async (value) => {
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        policyId: policyId,
        isExcludeYearEndAndRunoffReminders: value,
      }),
    };

    const policyLogs = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        Note: "Edit Exclude Year-End and Runoff Reminders: " + value,
        Action: "Policy Edit General Settings",
        PolicyId: policyId,
      }),
    };

    let response = await fetch(
      "/api/Settings/updateexcludeYearEndAndRunoffReminders",
      requestOptions
    );
    let data = await response.json();
    if (data.success === false) {
      alert(data.message);
      return;
    }
    await getExcludeYearEndAndRunoffReminders().then(() => {
      fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
    });
  };

  let editGeneralModal = null;
  if (showEditGeneralModal) {
    editGeneralModal = (
      <EditGeneralSettingModal
        modalLabel={"Edit Disable all automated PA and Employee emails"}
        options={["Yes", "No"]}
        showEditModal={showEditGeneralModal}
        selectedOption={automaticEmails}
        setSelectedOption={updateAutomaticEmailSetting}
        closeModal={() => setShowEditGeneralModal(false)}
        dropdownLabel={"Disable all automated PA and Employee emails"}
      />
    );
  }

  const renderModal = (ModalComponent, showModal, setShowModal, props) =>
    showModal && (
      <ModalComponent {...props} closeModal={() => setShowModal(false)} />
    );

  let contents = null;
  if (loading) {
    contents = <CustomLoading />;
  } else {
    contents = (
      <div
        className="appearance-setting-container"
        style={{ overflowY: "auto", height: "100%" }}
      >
        {editGeneralModal}
        {renderModal(
          EditGeneralSettingModal,
          showExcludeYearEndAndRunoffRemindersModel,
          setShowExcludeYearEndAndRunoffRemindersModel,
          {
            modalLabel: "Edit Exclude Year-End and Runoff Reminders",
            options: ["Yes", "No"],
            showEditModal: showExcludeYearEndAndRunoffRemindersModel,
            selectedOption: excludeYearEndAndRunoffReminders,
            setSelectedOption: updateExcludeYearEndAndRunoffReminders,
            dropdownLabel: "Exclude Year-End and Runoff Reminders:",
          }
        )}
        <Card
          actions={
            <a
              href="#"
              className="RT-Link"
              onClick={() => setShowExcludeYearEndAndRunoffRemindersModel(true)}
            >
              Edit
            </a>
          }
        >
          <Line>
            <div className="RT-Static-Field">
              <div className="RT-Static-Field__label">
                Exclude Year-End and Runoff Reminders
                <CustomToolTip
                  header="Exclude Year-End and Runoff Reminders"
                  bodyContent="Disable reminders for Year-End and Runoff notifications."
                />
              </div>
              <div className="RT-Static-Field__content">
                {excludeYearEndAndRunoffReminders}
              </div>
            </div>
          </Line>
        </Card>
        <Card
          actions={
            <>
              <a href="#" className="RT-Link" onClick={openEditGeneralModal}>
                Edit
              </a>
            </>
          }
        >
          <Line>
            <div className="RT-Static-Field">
              <div className="RT-Static-Field__label">
                Disable all automated PA and Employee emails
                 <CustomToolTip
                  header="Disable all automated PA and Employee emails"
                  bodyContent="Disable all automated PA and Employee emailing regarding Flex Selections and Flex Campaigns."
                />
              </div>
              <div className="RT-Static-Field__content">{automaticEmails}</div>
            </div>
          </Line>
        </Card>
      </div>
    );
  }

  return <div className="appearance-settings">{contents}</div>;
};

export default EmailSettings;
